import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NurserySettingStateType } from '../../../../types/src/lib/redux-types/nursery-settings-state.type';
import { NurserySettingsResponseType } from 'src/shared/types/src';

const initialState: NurserySettingStateType = {
    settingLoading: false,
    settings: {} as NurserySettingsResponseType,
}

const nurserySettingSlice = createSlice({
    name: 'nurserySettingSlice',
    initialState,
    reducers: {
        setSettingsLoading: (state, action: PayloadAction<boolean>) => {
            state.settingLoading = action.payload;
        },
        setSettingsData: (state, action: PayloadAction<NurserySettingsResponseType>) => {
            state.settings = {
                ...state.settings,
                ...action.payload
            }
        },
        resetNurserySettings: () => {
            return initialState;
        }
    }
});

export const nurserySettingAction = nurserySettingSlice.actions;
export default nurserySettingSlice.reducer;